import script from "./Advertise.vue?vue&type=script&lang=ts&setup=true"
export * from "./Advertise.vue?vue&type=script&lang=ts&setup=true"

import "./Advertise.vue?vue&type=style&index=0&id=3c86913d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c86913d"]])

export default __exports__